import { useCallback, useEffect, useState } from 'react';

/**
 * Universal Android APK & PWA setup modal.
 * Replaces js/apk-modal.js — still reachable from legacy controllers through window.openApkModal().
 */
export default function ApkModal() {
  const [open, setOpen] = useState(false);
  const [installPrompt, setInstallPrompt] = useState(null);

  const close = useCallback(() => setOpen(false), []);

  useEffect(() => {
    window.openApkModal = () => setOpen(true);
    window.closeApkModal = () => setOpen(false);
    const onPrompt = (e) => {
      e.preventDefault();
      setInstallPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', onPrompt);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      delete window.openApkModal;
      delete window.closeApkModal;
    };
  }, []);

  const notify = (msg, type = 'info') => (window.showToast ? window.showToast(msg, type) : alert(msg));

  const installPwa = () => {
    if (installPrompt) {
      installPrompt.prompt();
      installPrompt.userChoice.then((choice) => {
        if (choice.outcome === 'accepted') notify('Police Duty App added to your device Home Screen!', 'success');
        setInstallPrompt(null);
      });
    } else {
      alert('To add to home screen:\n1. Tap the 3 dots (\u22ee) menu in Chrome\n2. Tap "Install App" or "Add to Home screen"');
    }
  };

  const copyLink = () => {
    const fullUrl = window.location.origin + '/officer-app';
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(fullUrl)
        .then(() => notify('Copied duty app link to clipboard! Share on WhatsApp to officers.', 'success'));
    } else {
      window.prompt('Copy duty app link:', fullUrl);
    }
  };

  if (!open) return null;

  return (
    <div
      id="apk-download-modal"
      style={{ display: 'flex', zIndex: 99999 }}
      className="fixed inset-0 bg-black/85 backdrop-blur-md flex items-center justify-center p-4"
    >
<div className="bg-slate-900 border border-slate-700 rounded-3xl w-full max-w-2xl p-5 sm:p-7 shadow-2xl text-slate-200 flex flex-col max-h-[92vh] relative">
          {/* Header */}
          <div className="flex items-center justify-between pb-3 border-b border-slate-800 mb-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-tr from-emerald-600 via-teal-600 to-blue-600 flex items-center justify-center text-white shadow-xl text-2xl font-black shrink-0">
                📱
              </div>
              <div>
                <h3 className="text-base sm:text-lg font-black text-white flex items-center gap-2">
                  <span>
                    Police Staff Mobile App & APK
                  </span>
                  <span className="px-2 py-0.5 rounded text-[10px] font-bold bg-emerald-500/20 text-emerald-400 border border-emerald-500/30">
                    ANDROID & WEB
                  </span>
                </h3>
                <p className="text-xs text-slate-400">
                  Install native Android APK or log in directly via mobile web browser for 24h continuous live location tracking
                </p>
              </div>
            </div>
            <button type="button" onClick={(event) => { close() }} className="w-8 h-8 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-400 hover:text-white flex items-center justify-center text-2xl font-bold transition">
              ×
            </button>
          </div>
          <div className="space-y-4 overflow-y-auto flex-1 pr-1 text-xs">
            {/* Choice Banner: APK vs Web Page */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {/* Option 1: Download Android APK */}
              <div className="p-4 bg-gradient-to-b from-slate-800/90 to-slate-900 border-2 border-emerald-500/60 rounded-2xl flex flex-col justify-between shadow-lg relative overflow-hidden group">
                <div className="absolute -right-4 -bottom-4 text-7xl opacity-10 group-hover:opacity-20 transition pointer-events-none">
                  🤖
                </div>
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <span className="px-2 py-0.5 rounded-full text-[9px] font-black bg-emerald-500 text-slate-950 uppercase">
                      Recommended for Field Force
                    </span>
                    <span className="text-[10px] text-slate-400 font-mono">
                      v1.0.0 APK
                    </span>
                  </div>
                  <h4 className="text-sm font-bold text-white flex items-center gap-1.5">
                    <span>
                      📥
                    </span>
                    {' '}Download Android APK
                  </h4>
                  <p className="text-[11px] text-slate-300 mt-1 leading-relaxed">
                    Install package directly on Constable / HC Android smartphones. Runs background GPS service with auto-reconnect.
                  </p>
                </div>
                <div className="pt-3 mt-3 border-t border-slate-700/60 space-y-2">
                  <a href="/downloads/election-police-duty-tracker.apk" download="election-police-duty-tracker.apk" className="w-full py-2.5 bg-emerald-600 hover:bg-emerald-500 text-white rounded-xl font-bold flex items-center justify-center gap-2 shadow-lg shadow-emerald-950/50 transition">
                    <span>
                      📲
                    </span>
                    {' '}Download APK File (114 KB)
                  </a>
                  <div className="text-[10px] text-slate-400 text-center">
                    Package:{' '}
                    <span className="font-mono text-emerald-400 font-semibold">
                      in.gov.election.policetracker
                    </span>
                  </div>
                </div>
              </div>
              {/* Option 2: Login via Web Browser / PWA */}
              <div className="p-4 bg-gradient-to-b from-slate-800/90 to-slate-900 border-2 border-blue-500/60 rounded-2xl flex flex-col justify-between shadow-lg relative overflow-hidden group">
                <div className="absolute -right-4 -bottom-4 text-7xl opacity-10 group-hover:opacity-20 transition pointer-events-none">
                  🌐
                </div>
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <span className="px-2 py-0.5 rounded-full text-[9px] font-black bg-blue-500 text-white uppercase">
                      No Install Needed
                    </span>
                    <span className="text-[10px] text-slate-400 font-mono">
                      Any Browser
                    </span>
                  </div>
                  <h4 className="text-sm font-bold text-white flex items-center gap-1.5">
                    <span>
                      🌐
                    </span>
                    {' '}Open Web Duty App
                  </h4>
                  <p className="text-[11px] text-slate-300 mt-1 leading-relaxed">
                    Open instantly in Chrome, Firefox, Safari, or Samsung Internet. Install to Home Screen with 1 tap as Progressive Web App.
                  </p>
                </div>
                <div className="pt-3 mt-3 border-t border-slate-700/60 space-y-2">
                  <a href="/officer-app" className="w-full py-2.5 bg-blue-600 hover:bg-blue-500 text-white rounded-xl font-bold flex items-center justify-center gap-2 shadow-lg shadow-blue-950/50 transition">
                    <span>
                      🚀
                    </span>
                    {' '}Launch Webpage Duty App
                  </a>
                  <button type="button" id="btn-pwa-install-app" onClick={(event) => { installPwa() }} className="w-full py-2 bg-slate-800 hover:bg-slate-700 border border-blue-500/40 text-blue-300 rounded-xl font-bold flex items-center justify-center gap-1.5 transition">
                    <span>
                      📲
                    </span>
                    {' '}Add to Android Home Screen
                  </button>
                </div>
              </div>
            </div>
            {/* Instant Phone Camera QR Scanner Box */}
            <div className="p-3 bg-slate-950 rounded-2xl border border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                {/* Built-in SVG QR Code graphic */}
                <div className="w-20 h-20 bg-white p-1 rounded-xl shrink-0 flex items-center justify-center shadow-md">
                  <svg viewBox="0 0 100 100" className="w-full h-full" shapeRendering="crispEdges">
                    <rect width="100" height="100" fill="white"></rect>
                    {/* QR Marker Top Left */}
                    <rect x="10" y="10" width="28" height="28" fill="#0f172a"></rect>
                    <rect x="14" y="14" width="20" height="20" fill="white"></rect>
                    <rect x="18" y="18" width="12" height="12" fill="#0f172a"></rect>
                    {/* QR Marker Top Right */}
                    <rect x="62" y="10" width="28" height="28" fill="#0f172a"></rect>
                    <rect x="66" y="14" width="20" height="20" fill="white"></rect>
                    <rect x="70" y="18" width="12" height="12" fill="#0f172a"></rect>
                    {/* QR Marker Bottom Left */}
                    <rect x="10" y="62" width="28" height="28" fill="#0f172a"></rect>
                    <rect x="14" y="66" width="20" height="20" fill="white"></rect>
                    <rect x="18" y="70" width="12" height="12" fill="#0f172a"></rect>
                    {/* Data Points Pattern */}
                    <rect x="44" y="12" width="6" height="6" fill="#0f172a"></rect>
                    <rect x="52" y="20" width="6" height="6" fill="#0f172a"></rect>
                    <rect x="44" y="28" width="6" height="6" fill="#0f172a"></rect>
                    <rect x="12" y="44" width="6" height="6" fill="#0f172a"></rect>
                    <rect x="20" y="52" width="6" height="6" fill="#0f172a"></rect>
                    <rect x="28" y="44" width="6" height="6" fill="#0f172a"></rect>
                    <rect x="44" y="44" width="12" height="12" fill="#0f172a"></rect>
                    <rect x="62" y="44" width="6" height="6" fill="#0f172a"></rect>
                    <rect x="74" y="52" width="8" height="8" fill="#0f172a"></rect>
                    <rect x="44" y="62" width="6" height="6" fill="#0f172a"></rect>
                    <rect x="54" y="74" width="8" height="6" fill="#0f172a"></rect>
                    <rect x="66" y="66" width="14" height="6" fill="#0f172a"></rect>
                    <rect x="74" y="76" width="12" height="12" fill="#0f172a"></rect>
                  </svg>
                </div>
                <div>
                  <h5 className="font-bold text-white text-xs flex items-center gap-1.5">
                    <span>
                      📷
                    </span>
                    {' '}Scan with Android Phone Camera
                  </h5>
                  <p className="text-[11px] text-slate-300 mt-0.5">
                    Point any smartphone camera to open the Duty App or directly download the APK to phone memory.
                  </p>
                  <div className="text-[10px] text-emerald-400 font-mono font-semibold mt-1">
                    Direct Link: ./officer-app.html
                  </div>
                </div>
              </div>
              <button type="button" onClick={(event) => { copyLink() }} className="px-3 py-1.5 bg-slate-800 hover:bg-slate-700 border border-slate-700 text-slate-200 rounded-xl font-bold shrink-0 text-[11px] transition">
                📋 Copy Link
              </button>
            </div>
            {/* 4-Step Quick Instructions for Police Personnel */}
            <div className="p-3 bg-indigo-950/30 border border-indigo-700/50 rounded-2xl space-y-1.5 text-xs">
              <div className="font-bold text-indigo-300 uppercase text-[10px] tracking-wider flex items-center gap-1.5">
                <span>
                  🛡️
                </span>
                {' '}Police Officer Device Setup Instructions (Step-by-Step):
              </div>
              <ol className="list-decimal pl-4 space-y-1 text-slate-300 text-[11px]">
                <li>
                  <strong>
                    Download APK or Open Link:
                  </strong>
                  {' '}Tap{' '}
                  <em>
                    "Download APK"
                  </em>
                  {' '}above or open in mobile Chrome.
                </li>
                <li>
                  <strong>
                    Enable Unknown Sources (For APK):
                  </strong>
                  {' '}If prompted, allow Chrome to{' '}
                  <em>
                    "Install unknown apps"
                  </em>
                  {' '}→ Tap{' '}
                  <strong>
                    Install
                  </strong>
                  .
                </li>
                <li>
                  <strong>
                    Location Permission:
                  </strong>
                  {' '}When prompted, select{' '}
                  <strong>
                    "Allow all the time"
                  </strong>
                  {' '}or{' '}
                  <strong>
                    "While using app"
                  </strong>
                  {' '}so your 24h duty track is sent to Sub-Inspector.
                </li>
                <li>
                  <strong>
                    Duty Login:
                  </strong>
                  {' '}Select your name & enter default Duty PIN:{' '}
                  <strong className="text-white font-mono bg-slate-800 px-1.5 py-0.2 rounded">
                    1234
                  </strong>
                  .
                </li>
              </ol>
            </div>
          </div>
          {/* Footer */}
          <div className="pt-3 border-t border-slate-800 mt-3 flex items-center justify-between text-xs">
            <span className="text-slate-400">
              State Police Telecom & Cyber Operations Wing
            </span>
            <button type="button" onClick={(event) => { close() }} className="px-4 py-2 bg-slate-800 hover:bg-slate-700 text-white rounded-xl font-bold transition">
              Close
            </button>
          </div>
        </div>
    </div>
  );
}
